/** No topo do álbum do dia: o resumo daquele dia. */
import { featureEnabled } from '@nv/core';

import { useTrip } from '../../trip/TripContext';
import { useResumoDoDia } from './api';
import { ResumoDoDiaCard } from './ResumoDoDiaCard';

export function ResumoNoAlbum({ dayId }: { dayId: string | null }) {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'resumo_do_dia');
  const resumo = useResumoDoDia(tripId, dayId, ligado);
  if (!ligado || !resumo.data) return null;
  return <ResumoDoDiaCard resumo={resumo.data} />;
}
